import { render } from "./ScreenshotViewer.vue?vue&type=template&id=596a46b7&scoped=true"
import script from "./ScreenshotViewer.vue?vue&type=script&lang=js"
export * from "./ScreenshotViewer.vue?vue&type=script&lang=js"

import "./ScreenshotViewer.vue?vue&type=style&index=0&id=596a46b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596a46b7"]])

export default __exports__